module.exports = __webpack_public_path__ + "img/1728955744132-Screenshot_15-10-2024_92856_www.instagram.com.jpeg.d8c93bab.webp";